import { Attribute, EntityItem } from 'api/ApiTypes'
import { RepeatableAddress } from 'context/ContactContext'
import AttributeUtils from 'utils/AttributeUtils'
import { RepeatablePaymentOption } from 'utils/PaymentUtils'

export const getRelationPayments = (value: any, relations: EntityItem[]) => {
  const payments: any = AttributeUtils.findValueFromRelations(
    value,
    relations
  ) as RepeatablePaymentOption

  if (!payments?.length) {
    return []
  }

  return payments
}

export const getRelationAddress = (value: any, relations: EntityItem[]) => {
  const addresses =
    (AttributeUtils.findValueFromRelations(
      value,
      relations
    ) as RepeatableAddress[]) || []

  if (!addresses?.length) {
    return []
  }

  return addresses
}

/**
 * Reads a single primitive out of a repeatable attribute value.
 *
 * Depending on how the entity data was written, fields like `email` or `phone`
 * can arrive as a repeatable array (`[{ phone: '+49…' }]`), as a single object
 * (`{ phone: '+49…', _tags: ['work'] }`) or as a plain string. Returning the
 * nested primitive keeps callers from rendering an object.
 */
export const getRepeatableAttributeValue = (
  value: unknown,
  key: string
): string | undefined => {
  const item = Array.isArray(value) ? value[0] : value

  if (typeof item === 'string') {
    return item || undefined
  }

  if (item && typeof item === 'object') {
    const nestedValue = (item as Record<string, unknown>)[key]

    return typeof nestedValue === 'string'
      ? nestedValue || undefined
      : undefined
  }

  return undefined
}

export const getRepeatedValue = (attribute: Attribute, value: any[]) => {
  const valueAttributeName =
    attribute.type === 'string' ? 'value' : attribute.type

  if (!value?.length) {
    return []
  }

  return value.map((item) => item[valueAttributeName])
}

export const isEmptyValue = (value: any) =>
  value === undefined || value === null || value === ''
